import type { Ref } from 'vue'
import { useRouter } from 'vue-router'
import { useCalculationStore } from '@/stores/calculation'
import { useConfirmDeleteStore } from '@/stores/confirmDelete'

export const useCalculationNavigation = (params: {
  projectId: Ref<number>
  calculationId: Ref<number>
}) => {
  const { projectId, calculationId } = params
  const router = useRouter()
  const calculationStore = useCalculationStore()
  const confirmDeleteStore = useConfirmDeleteStore()

  const navigateToInput = () => {
    router.push({
      name: 'calculation-form',
      params: { id: projectId.value, calculationId: calculationId.value }
    })
  }

  const navigateBackToProject = () => {
    router.push({ name: 'project-detail', params: { id: projectId.value } })
  }

  const resetCalculation = async () => {
    await calculationStore.resetCalculation(calculationId.value, projectId.value)
    navigateToInput()
  }

  const confirmReset = async () => {
    const confirmed = await confirmDeleteStore.confirm({
      title: 'Reset calculation',
      message: 'Reset this calculation to draft? Existing results will be cleared.',
      confirmText: 'Reset'
    })
    if (!confirmed) return
    await resetCalculation()
  }

  return { navigateToInput, navigateBackToProject, confirmReset }
}
